// extracted by mini-css-extract-plugin
module.exports = {"HowOrder":"HowOrder_HowOrder__1LSgn","Title":"HowOrder_Title__3eU4D","Section":"HowOrder_Section__3Op_i","Highlight":"HowOrder_Highlight__3Kt2R"};